import React from "react";
import { ArrowRight, Sparkles, PlayCircle } from "lucide-react";
import { candidate } from "../mock";

const Hero = () => {
  return (
    <section id="domov" className="relative bg-campaign-blue pt-24 sm:pt-28 pb-0 overflow-hidden">
      {/* decorative rotating badge - volebné číslo */}
      <div className="hidden md:flex absolute top-28 right-8 z-20 w-32 h-32 rounded-full bg-campaign-yellow border-4 border-campaign-ink flex-col items-center justify-center animate-spin-slow">
        <span className="font-display text-campaign-ink text-center text-[10px] leading-tight uppercase">
          Volebné číslo
        </span>
        <span className="font-display text-campaign-ink text-4xl leading-none">
          {candidate.ballotNumber}
        </span>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-8 items-end">
          {/* Left text */}
          <div className="pb-10 lg:pb-20">
            <div className="inline-flex items-center gap-2 bg-campaign-yellow text-campaign-ink font-bold uppercase text-xs sm:text-sm px-3 py-1.5 border-2 border-campaign-ink -rotate-1 mb-6">
              <Sparkles size={16} /> {candidate.role} · {candidate.city}
            </div>

            <h1 className="font-display text-campaign-cream leading-[0.9] text-5xl sm:text-7xl xl:text-8xl">
              JÁN<br />
              <span className="text-campaign-yellow">KURÁŇ</span>
            </h1>

            <p className="mt-6 font-display text-campaign-yellow text-xl sm:text-3xl uppercase">
              {candidate.tagline}
            </p>
            <p className="mt-4 font-display text-campaign-cream text-lg sm:text-2xl uppercase">
              {candidate.leadLine}
            </p>
            <p className="mt-4 text-campaign-cream/90 text-base sm:text-lg max-w-xl leading-relaxed">
              {candidate.subTagline}
            </p>

            {/* Volebné číslo - výrazné */}
            <div className="mt-8 inline-flex items-center gap-4 bg-campaign-coral border-4 border-campaign-ink shadow-brutal px-5 py-3">
              <span className="font-display uppercase text-campaign-cream text-sm sm:text-base leading-tight">
                Volebné<br className="hidden sm:block" /> číslo
              </span>
              <span className="font-display text-campaign-cream text-5xl sm:text-6xl leading-none">
                {candidate.ballotNumber}
              </span>
            </div>

            <div className="mt-8 flex flex-wrap gap-4">
              <a
                href="#program"
                className="inline-flex items-center gap-2 bg-campaign-yellow text-campaign-ink font-display uppercase text-base px-6 py-4 border-2 border-campaign-ink shadow-brutal hover-lift"
              >
                Môj program <ArrowRight size={20} />
              </a>
              <a
                href="#manifest"
                className="inline-flex items-center gap-2 bg-campaign-coral text-campaign-cream font-display uppercase text-base px-6 py-4 border-2 border-campaign-ink shadow-brutal hover-lift"
              >
                <PlayCircle size={20} /> Moje vízie vo videu
              </a>
            </div>
          </div>

          {/* Right photo */}
          <div className="relative flex justify-center lg:justify-end">
            <div className="absolute bottom-0 w-[85%] h-[85%] bg-campaign-yellow border-4 border-campaign-ink translate-x-4 translate-y-0" />
            <img
              src={candidate.photo}
              alt={candidate.fullName}
              className="relative z-10 w-full max-w-md object-cover object-top border-4 border-campaign-ink"
              style={{ maxHeight: "560px" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
